onDomReady(function() {
   (function setBackgroundImages() {
      // Update image source to be src if currentSrc is falsey (undefined)
      function update(img) {
         var src = img.currentSrc || img.src;
         img.getParent().style.backgroundImage = 'url("' + src + '")';
      }

      // Add an event listener to all .bg-img-src elements
      $$('.bg-img-src').forEach(function(img) {
         img.addEventListener('load', function() {
            update(img);
         });
      });

      // Call update on all listed elements if img is done already loading
      $$('.bg-img-src')
         .filter(function(img) {
            return img.complete;
         })
         .forEach(update);
   })();
});
